export default __webpack_public_path__ + "static/media/pic17.168769e9.jpg";